import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import router from '@/router'
import lookups from '@/assets/json/clientLookups.json'

const mapPersonObject = (person) => {
  const formStore = useFormStore()

  const {
    unifiedNumber,
    familyHeadIdentityNumber,
    genderId,
    familyRelationshipId,
    familyBookNumber,
    englishFirstName,
    arabicFirstName,
    englishFatherName,
    arabicFatherName,
    englishGrandName,
    arabicGrandName,
    englishFourthName,
    arabicFourthName,
    englishFamilyName,
    arabicFamilyName,
    englishMotherName,
    arabicMotherName,
    dateOfBirth,
    englishPlaceOfBirth,
    arabicPlaceOfBirth,
    countryOfBirthId,
    martialStatusId,
    tribeId,
    mobileNumber,
    emirateOfBirthId,
    cityOfBirthId,
    familyBookCityCode,
    familySequence,
    localFamilyRecordDate,
    familyHeadGenderId
  } = person
  const values = {
    personUnifiedNumber: unifiedNumber,
    motherIdentityNumber: familyHeadGenderId == lookups.gender.female && familyHeadIdentityNumber,
    fatherIdentityNumber: familyHeadGenderId == lookups.gender.male && familyHeadIdentityNumber,
    genderId: genderId,
    familyRelationshipId: familyRelationshipId,
    familyBookNo: familyBookNumber,
    sponsoredFirstNameEnglish: englishFirstName,
    sponsoredFirstNameArabic: arabicFirstName,
    sponsoredSecondNameEnglish: englishFatherName,
    sponsoredSecondNameArabic: arabicFatherName,
    sponsoredThirdNameEnglish: englishGrandName,
    sponsoredThirdNameArabic: arabicGrandName,
    sponsoredFourthNameEnglish: englishFourthName,
    sponsoredFourthNameArabic: arabicFourthName,
    sponsoredFamilyNameEnglish: englishFamilyName,
    sponsoredFamilyNameArabic: arabicFamilyName,
    motherEnglishName: englishMotherName,
    motherArabicName: arabicMotherName,
    dateOfBirth: dateOfBirth,
    englishPlaceOfBirth: englishPlaceOfBirth,
    arabicPlaceOfBirth,
    countryOfBirthId,
    maritalStatusId: martialStatusId,
    tribeId,
    localMobile: mobileNumber,
    sponsoredBirthEmirateId: emirateOfBirthId,
    sponsoredBirthCityId: cityOfBirthId,
    sponsorRelationshipId: familyRelationshipId,
    familyBookNo: familyBookNumber,
    familyCity: familyBookCityCode,
    familySerial: familySequence,
    familyStartDate: localFamilyRecordDate
  }


  formStore.draft.request = {
    ...formStore.draft.request,
    ...values
  }
}

const fetchPerson = async (personUN) => {
  return await apiHelperService.get(`/api/icaRequest/getPerson/${personUN}`)
}

const setInitData = async () => {
  const formStore = useFormStore()
  const personUN = router.currentRoute.value.query.personUN

  formStore.draft.request = {
    ...formStore.draft.request,
    ...{
      applicantClassId: lookups.applicatClassType.citizen,
      religionId: lookups.religion.islam,
      personUnifiedNumber: personUN,
      currentNationalityId: lookups.uaeNationality
    }
  }

  const response = await fetchPerson(personUN)
  mapPersonObject(response)
}

export default async function () {
  const formStore = useFormStore()

  try {
    formStore.extraMap = {
      localAddressUserActionEnum: null,
      administrativeRegionId: null
    }
    await setInitData()
  } catch (error) {
    console.error('use585Preload', error)
  }
}
